import React, { useEffect, useRef, useState } from "react";
import { Box, LabelStyled } from "../../styled/Elements";
import { Form, FormGroup } from "react-bootstrap";
import styled from "styled-components";
import { EyeClosed, EyeOpened } from "../../styled/AllImages";
import { useTranslation } from "react-i18next";
import ValidationErrorText from "./ValidationErrorText";

const ValidatedInput = ({
  name,
  type,
  fieldType,
  placeholder,
  label,
  value,
  register,
  validationRules,
  className,
  disabled,
  errors,
  sectIndex,
  staric,
  classNameLabel,
  errorDisplay,
  padding,
  column,
  start,
  weight,
  errorMessage = "",
  ...rest
}) => {
  const { t } = useTranslation();
  const [showType, setType] = useState(fieldType);

  const inputStyles = type === "textarea" ? { height: "130px", color: "var(--text)" } : {color: "var(--text)"};
  const inputRef = useRef(null);

  useEffect(() => {
    if (fieldType === "number" && inputRef.current) {
      const input = inputRef.current;
      const preventScroll = (e) => e.preventDefault();
      input.addEventListener("wheel", preventScroll, { passive: false });
      return () => input.removeEventListener("wheel", preventScroll);
    }
  }, [fieldType]);

  return (
    <ValidatedInputWrapper padding={padding && padding} column={column} start={start} className={className} {...rest}>
      <FormGroup controlId={name} className="formEleContainer">
        {label && (
          <LabelStyled
            className={classNameLabel}
            size="15px"
            color="var(--text)"
            weight={weight ? weight : ""}
          >
            {t(label)}
            {staric && <span className="staric">*</span>}
          </LabelStyled>
        )}
        <Box className="position-relative w-100">
          <Form.Control
            onWheel={(e) => {
              e.target.blur()
            }}
            as={type}
            ref={inputRef}
            type={showType}
            value={value}
            disabled={disabled}
            placeholder={t(placeholder)}
            style={inputStyles}
            min={fieldType === "number" ? 0 : undefined}
            onKeyDown={(e) => {
              if (fieldType === "number" && (e.key === "-" || e.key === "e")) {
                e.preventDefault();
              }
            }}
            {...(register && register(name, validationRules))}
          />
          {fieldType === "password" && (
            <>
              {showType === "password" ? (
                <EyeClosed
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("text")}
                />
              ) : (
                <EyeOpened
                  className="eye-btn position-absolute cursor-pointer"
                  onClick={() => setType("password")}
                />
              )}
            </>
          )}

          {errors && (
            <>
              {errors[name]?.type === "required" && (
                <ValidationErrorText
                  text={
                    t(errors[name]?.message) ||
                    `${t(label || name)} ${t("isRequired")}.`
                  }
                  extraClass={errorDisplay}
                />
              )}
              {errors?.users?.[sectIndex]?.name?.type === "required" && (
                <ValidationErrorText
                  text={
                    t(errors.users?.[sectIndex]?.name?.message) ||
                    `${t(label || "name")} ${t("isRequired")}.`
                  }
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "minLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "maxLength" && (
                <ValidationErrorText
                  text={t(errors[name]?.message)}
                  extraClass={errorDisplay}
                />
              )}

              {errors[name]?.type === "pattern" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
              {errors[name]?.type === "validate" && (
                <ValidationErrorText
                  text={t(errors[name]?.message || errorMessage)}
                  extraClass={errorDisplay}
                />
              )}
            </>
          )}
        </Box>
      </FormGroup>
    </ValidatedInputWrapper>
  );
};

export default ValidatedInput;

export const ValidatedInputWrapper = styled.div`
  width: 100%;
  /* height: 102px; */
  padding: ${({padding}) => padding ? padding : "9px 25px 9px 25px"};
  /* border-bottom: 1px solid var(--borderLight); */
  .formEleContainer {
    display: flex;
    flex-direction: ${({column}) => (column ? "column" : "row")};
    align-items: ${({start}) => (start ? "flex-start" : "center")};
    padding: 7px 0px 7px 0px;
    margin: 7px 0 7px 0;
    gap: 5px;
    & > label {
      min-width: 160px;
      body.rtl & {
        font-family: var(--arRegular);
      }

      &.w-auto {
        min-width: auto;
      }
    }
    &.inp-white {
      input {
        background-color: var(--white);
      }
    }
  }
  &.combined {
    border-bottom: none;
    padding: 8px 25px 8px 25px;
    /* &:last-child{
            border-bottom: 1px solid var(--borderLight);
        } */
    .formEleContainer {
      display: flex;
      padding: 0;
      margin: 0;
    }
  }
  &.flex-wrap {
    .formEleContainer {
      flex-wrap: wrap;
      label {
        width: 100%;
      }
    }
  }
  .form-floating {
    width: 100%;
  }
  input[type="text"] {
    width: 100%;
  }

  .form-control {
    height: 48px;
    box-shadow: none;
    outline: none;
    border-radius: 10px;
    border: 1px solid var(--border);
    background-color: ${({ bg }) => (bg ? bg : "var(--white)")};
    &::placeholder {
      color: var(--textPlaceholder2);
    }
  }
  .form-control:focus {
    box-shadow: none;
    outline: none;
    border: 1px solid var(--border);
  }
  @media (max-width: 767px) {
    .formEleContainer {
      flex-wrap: wrap;
      gap: 3px;
      margin: 0;
      padding: 3px 0px 3px 0px;
      label {
        width: 100%;
      }
    }
  }
`;
